import config from './config';
import { IDealroadshowConfig } from './IDealroadshowConfig';

export type { IDealroadshowConfig };

export default config;
